export default __webpack_public_path__ + "static/media/june1.db0d4d18.jpg";